<div class="home-form">
    @if (americanView) {
        @if (awayTeamAwayForm) {
            <ms-form-indicator [outcomes]="awayTeamAwayForm" />
        }
        @if (overallAwayTeamForm) {
            <ms-form-indicator [outcomes]="overallAwayTeamForm" />
        }
    } @else {
        @if (homeTeamHomeForm) {
            <ms-form-indicator [outcomes]="homeTeamHomeForm" />
        }
        @if (overallHomeTeamForm) {
            <ms-form-indicator [outcomes]="overallHomeTeamForm" />
        }
    }
</div>

<div class="away-form">
    @if (americanView) {
        @if (homeTeamHomeForm) {
            <ms-form-indicator [outcomes]="homeTeamHomeForm" />
        }
        @if (overallHomeTeamForm) {
            <ms-form-indicator [outcomes]="overallHomeTeamForm" />
        }
    } @else {
        @if (awayTeamAwayForm) {
            <ms-form-indicator [outcomes]="awayTeamAwayForm" />
        }
        @if (overallAwayTeamForm) {
            <ms-form-indicator [outcomes]="overallAwayTeamForm" />
        }
    }
</div>
